module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0860.0a13b13d.jpg";